import script from "./PartialCancellation.vue?vue&type=script&lang=ts&setup=true"
export * from "./PartialCancellation.vue?vue&type=script&lang=ts&setup=true"

import "./PartialCancellation.vue?vue&type=style&index=0&id=2786929c&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2786929c"]])

export default __exports__